module.exports = __webpack_public_path__ + "static/media/speaker.62efe40f.svg";